<template>
  <div class="register_container">
    <div class="title">
      注册账号
    </div>
    <van-form v-show="showStep1">
      <van-field
        v-model.trim="captchaForm.mobile"
        placeholder="请输入手机号"
        autocomplete="new-password"
        class="field_item"
      />

      <van-field
        v-model.trim="captchaForm.code"
        placeholder="请输入验证码"
        autocomplete="new-password"
        class="field_item "
      >
        <template #button>
          <span class="code" @click="getCode" v-if="state.smsSendBtn">
            获取验证码
          </span>
          <span v-else class="code2">
            {{ '(' + state.time + 's)后重新发送' }}
          </span>
        </template>
      </van-field>

      <div class="agree">
        <van-checkbox
          v-model="checked"
          checked-color="#f93244"
          icon-size="14px"
          shape="square"
        >
          已仔细阅读并同意
          <span class="red">《用户使用协议》</span></van-checkbox
        >
      </div>
      <div class="pwd_btn">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#F93244"
          :disabled="!captchaForm.mobile || !captchaForm.code || !checked"
          @click="nextStep"
        >
          下一步
        </van-button>
      </div>
    </van-form>
    <van-form @submit="onSubmit" v-show="showStep2">
      <van-field
        v-model.trim="registerForm.username"
        placeholder="请输入用户名"
        autocomplete="new-password"
        class="field_item"
      />
      <van-field
        v-model.trim="registerForm.password"
        placeholder="请输入密码"
        autocomplete="new-password"
        class="field_item"
        type="password"
      />
      <van-field
        v-model.trim="registerForm.rePassword"
        placeholder="再次确认密码"
        autocomplete="new-password"
        class="field_item"
        type="password"
      />
      <div class="pwd_btn">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#F93244"
          :disabled="!registerForm.password || !registerForm.rePassword"
        >
          立即注册
        </van-button>
      </div>
    </van-form>

    <div class="action_btn">
      已有账号，
      <span class="red" @click="openLink('/login')">立即登录 </span>
    </div>
  </div>
</template>

<script>
import { sipSms, sipRegister, accountInviterCheck } from '@/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';

export default {
  data() {
    return {
      captchaForm: {
        mobile: '',
        code: ''
      },
      registerForm: {
        username: '',
        password: '',
        rePassword: ''
      },
      state: {
        time: 60,
        smsSendBtn: true
      },
      checked: false,
      showStep1: true,
      showStep2: false,
      inviterCode: ''
    };
  },
  created() {
    const inviterCode = this.$route.query.c;
    if (inviterCode) {
      Vue.ls.set('inviterCode', this.$route.query.c);
      // 先检查是否通过
      accountInviterCheck(inviterCode).then((check) => {
        if (check.success) {
          this.inviterCode = inviterCode;
        }
      });
    }
  },
  methods: {
    nextStep() {
      const { captchaForm } = this;
      if (!captchaForm.mobile.trim() || !captchaForm.code.trim()) {
        return this.$toast.fail('请先输入手机号和验证码');
      }
      this.showStep2 = true;
      this.showStep1 = false;
    },
    onSubmit() {
      const { registerForm, inviterCode, captchaForm } = this;
      if (
        !registerForm.username.trim() ||
        !this.registerForm.password.trim() ||
        !this.registerForm.rePassword.trim()
      ) {
        return this.$toast.fail('请输入完整的内容');
      }
      if (!/^[a-zA-Z]\w{5,16}$/.test(registerForm.username)) {
        return this.$toast.fail('账号以小写字母开头加数字，6~16位');
      }
      if (registerForm.password.length < 6) {
        return this.$toast.fail('密码至少6个字符');
      }
      if (registerForm.rePassword !== registerForm.password) {
        return this.$toast.fail('密码与确认密码不一致');
      }
      // 如果通过邀请码进入的话，把c设置上
      if (inviterCode) {
        registerForm.inviterCode = inviterCode;
      }
      // 设置注册方式
      registerForm.type = 1;
      // 设置来源站
      registerForm.host = baseData.host;
      //分站uid
      registerForm.oemUid = baseData.uid;
      const params = Object.assign(captchaForm, registerForm);
      sipRegister(params).then((res) => {
        if (res.success) {
          this.$toast.success('注册成功，请前往登录');
          setTimeout(() => {
            this.$router.push('/login');
          }, 1000);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    openLink(path) {
      this.$router.push(path);
    },
    getCode() {
      const { state, captchaForm } = this;
      if (!captchaForm.mobile.trim()) {
        return this.$toast.fail('请输入手机号');
      }
      if (!/^1[3456789]\d{9}$/.test(captchaForm.mobile)) {
        return this.$toast.fail('请输入正确的手机号');
      }
      state.smsSendBtn = false;
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 60;
          state.smsSendBtn = true;
          window.clearInterval(interval);
        }
      }, 1000);
      sipSms(captchaForm.mobile, 1)
        .then((res) => {
          if (res.success) {
            this.$toast.success('验证码获取成功');
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          clearInterval(interval);
          state.time = 60;
          state.smsSendBtn = true;
          this.$toast.fail(err.message);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.register_container {
  padding: 19.733vw 0;
  .red {
    color: #f93244;
  }
  .title {
    padding-left: 4.267vw;
    font-size: 7.467vw;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8.533vw;
  }
  .field_item {
    height: 14.933vw;
    margin-bottom: 4.267vw;
    display: flex;
    align-items: center;
    font-size: 4.533vw;
    color: rgba(0, 0, 0, 0.25);
    .code {
      font-size: 4.533vw;
      color: #f93244;
      padding: 6px 10px;
    }
    .code2 {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .agree {
    color: rgba(0, 0, 0, 0.65);
    margin-left: 4.267vw;
    font-size: 3.467vw;
  }
  .pwd_btn {
    padding: 24.533vw 4.267vw 5.333vw;
  }
  .action_btn {
    text-align: center;
    color: rgba(0, 0, 0, 0.25);
    font-size: 3.733vw;
  }
}
</style>
